var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV6HomeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.53906L13.0859 3.04688L23.3984 11.7969L22.1875 13.2422L21.25 12.4219V21.5625V22.5H20.3125H4.6875H3.75V21.5625V12.4219L2.77344 13.2422L1.5625 11.7969L11.875 3.04688L12.5 2.53906ZM12.5 5L5.625 10.8203V20.625H8.75V14.0625V13.125H9.6875H15.3125H16.25V14.0625V20.625H19.375V10.8203L12.5 5ZM10.625 20.625H14.375V15H10.625V20.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV6HomeIcon);
export default __webpack_public_path__ + "static/media/v6-home-icon.f67d6b496ce44b4bff3c0fb911a5136d.svg";
export { ForwardRef as ReactComponent };